import React from 'react';
import { t } from 'i18next';
import {
  SimpleForm,
  TextInput
} from 'react-admin';

import { isRequired } from '../../utils/validation';

const validateRequired = [isRequired()];

export const ProductGroupForm = props => (
  <SimpleForm {...props} redirect="list">
    <TextInput source="name" label={t('name')} validate={validateRequired}/>
  </SimpleForm>
);
